module.exports = __webpack_public_path__ + "static/media/termsAndConditions.70898e98.png";